import React from "react";
import ayyaPho from '../img/aiyaReplacement.jpg';
// Framer Motion
import {motion} from 'framer-motion';
import Wave from "./Wave";
// Animation
import { titleAnim, fade, photoAnim } from "../animation";
// Styled Components
import { About, Description, Hide } from "../styles";
import styled from 'styled-components';


const AboutSection = () => {

    return (
        <About>
            <Description>
                <motion.div>
                    <Hide>
                        <motion.h1 variants={titleAnim}>Shenuque Tissera</motion.h1>
                    </Hide>
                    <Hide>
                        <motion.h2 variants={titleAnim}>Actor. <span>Comedian.</span> Writer.</motion.h2>
                        <a href="https://docs.google.com/forms/d/1yXiRo2mYSlWRrvRmYtrWobjI6IbLsESX9-R5KXjYv7I/viewform?edit_requested=true&fbclid=PAZnRzaAN5B9pleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAaduhOGyGpgI7PmVd5b79z4a6rWfNLmNrhUhgT3drbjHxGMb0qAvelwaaHHOwQ_aem_-PCcfmoo2NiDeTp-FmACrA" target="_blank"><motion.button variants={fade}>Join my Mailing List</motion.button></a>
                    </Hide>                                      
                </motion.div>
                <Summary variants={fade}>
                    Shenuque is a Queer Sri Lankan actor, writer, and comedian hailing from Staten Island, New York. With a passion for storytelling, they've graced the stage in Off-Broadway productions and contributed their writing talents to HBO Max. They've worked as a director for the Murmartion Theater Company.               
                </Summary>       
                <Summary variants={fade}>
                    As a co-founder of Many Sided Media, Shenuque's creativity shines in the show My First Dungeon, which has won numerous awards.
                </Summary>    
                <Summary variants={fade}>
                    Currently, Shenuque is currently touring their stand-up special, 'Wait, What's Sri Lanka?' A show about invisible identities exploring race, gender and sexuality. They are also working on a short film inspired by the song Mr. Brightside by the Killers. 
                </Summary> 
                <Summary variants={fade}>
                    You can find their content on <a href="https://www.instagram.com/shenuque/" target="_blank" id="ig-a-link">Instagram</a>, <a href="https://www.facebook.com/ShenuqueTissera/" target="_blank">Facebook</a> and <a href="https://www.tiktok.com/@fakeshenuque?lang=en" target="_blank" id="tiktok-a-link">TikTok</a>! If you want them to bring a show to your city, join their email list!
                </Summary>     
            </Description>
            <FrontPageImg>
                <motion.img variants={photoAnim} src={ayyaPho} alt="photo" />
            </FrontPageImg>
            <Wave />
        </About>
    );
};

const Summary = styled(motion.p)`
    padding: 1rem 0rem;
    font-size: 1.2rem;

    #ig-a-link{
        color: #8a3ab9;
    }
    #tiktok-a-link{
        color: black;
    }
`;

const FrontPageImg = styled(motion.div)`
    z-index: 2;
    flex: 1;
    overflow: hidden;
    img{
        width: 90%;
        height: auto;
        object-fit: cover;
    }
    @media (max-width: 480px){
        img{
        width: 80%;
    }
    }
    @media (max-width: 576px){
        img{
        width: 80%;
    }
    }
`;

export default AboutSection;